import React from 'react';

const PaymentProcess = {
  title: 'Payment Process',
  items: [
    {
      header: 'What should I do if the traveler asks for payment in another currency?',
      content: (
        <div>
          <p>Even though prices can be displayed in many currencies, only payment in Thai Baht is allowed on the system.</p>
        </div>
      )
    },
    {
      header: 'Can I accept cash from the traveler?',
      content: (
        <div>
          <p>Due to our safety policy, we do not accept cash from travelers under any circumstances. If you accept cash from the traveler, your insurance and safety provided by us will not be covered in that booking and you may face the suspension penalty for 1 year.</p>
        </div>
      )
    },
    {
      header: 'What can I do if I have to ask the traveler for extra payment?',
      content: (
        <div>
          <p>In case you have to ask your traveler for extra payment, please contact us at <a href="mailto:support@takemetour.com">support@takemetour.com</a> as soon as possible for more details. </p>
        </div>
      )
    },
    {
      header: 'What is the add-on hotel pickup service?',
      content: (
        <div>
          <p>This add-on allows travelers to request hotel pickup service for trips that don’t include the pickup service. By offering the add-on hotel pickup service to travelers, you can accept and receive extra payment in return.</p>
          <p>If you can’t provide the service, you may click ‘No’. We will do our best to arrange a taxi service for travelers to ensure they can meet you at the meeting point.</p>
        </div>
      )
    }
  ]
};

export default PaymentProcess;
